import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Eye, Palette, Hash, Users, Sparkles, Home } from 'lucide-react';

// Training Hub - 4 section grid
export const TrainingHub = ({ onBack, onSelectModule, onHome }) => {
  const modules = [
    {
      id: 'zener',
      title: 'Zener',
      subtitle: 'Sembol Algılama',
      icon: Eye,
      color: 'violet',
      gradient: 'from-violet-500/20 to-purple-500/20',
      borderColor: 'border-violet-500/30',
      iconColor: 'text-violet-400'
    },
    {
      id: 'color',
      title: 'Renk',
      subtitle: 'Renk Algılama',
      icon: Palette,
      color: 'cyan',
      gradient: 'from-cyan-500/20 to-blue-500/20',
      borderColor: 'border-cyan-500/30',
      iconColor: 'text-cyan-400'
    },
    {
      id: 'number',
      title: 'Rakam',
      subtitle: 'Sayı Algılama',
      icon: Hash,
      color: 'amber',
      gradient: 'from-amber-500/20 to-orange-500/20',
      borderColor: 'border-amber-500/30',
      iconColor: 'text-amber-400'
    },
    {
      id: 'telepathy',
      title: 'Telepati',
      subtitle: 'İkili Algılama',
      icon: Users,
      color: 'pink',
      gradient: 'from-pink-500/20 to-rose-500/20',
      borderColor: 'border-pink-500/30',
      iconColor: 'text-pink-400'
    }
  ];

  return (
    <div className="min-h-screen flex items-center justify-center p-4" data-testid="training-hub">
      <button
        onClick={onBack}
        className="fixed top-6 left-6 z-40 glass-panel p-3 text-slate-400 hover:text-white transition-all"
      >
        <ArrowLeft className="w-5 h-5" />
      </button>
      
      {/* Home Button */}
      <button
        onClick={onHome || onBack}
        className="fixed top-6 right-6 z-40 glass-panel p-3 text-slate-400 hover:text-white transition-all flex items-center gap-2"
        data-testid="home-button"
      >
        <Home className="w-5 h-5" />
        <span className="text-sm">Home</span>
      </button>

      <motion.div
        className="max-w-lg w-full space-y-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        {/* Header */}
        <div className="text-center space-y-2">
          <motion.div
            className="w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br from-violet-500/20 to-cyan-500/20 flex items-center justify-center border border-violet-500/30"
            animate={{ scale: [1, 1.05, 1] }}
            transition={{ duration: 3, repeat: Infinity }}
          >
            <Sparkles className="w-8 h-8 text-violet-400" />
          </motion.div>
          <h1 className="text-2xl font-heading text-slate-100">Eğitim Merkezi</h1>
          <p className="text-slate-400 text-sm">Sezgisel yeteneklerinizi geliştirin</p>
        </div>

        {/* 4-Section Grid */}
        <div className="grid grid-cols-2 gap-4">
          {modules.map((module, index) => {
            const Icon = module.icon;
            return (
              <motion.button
                key={module.id}
                onClick={() => onSelectModule(module.id)}
                className={`aspect-square rounded-3xl bg-gradient-to-br ${module.gradient} border ${module.borderColor} p-6 flex flex-col items-center justify-center gap-3 hover:scale-105 transition-all group`}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                data-testid={`training-module-${module.id}`}
              >
                <div className={`w-14 h-14 rounded-2xl bg-slate-900/50 flex items-center justify-center ${module.iconColor} group-hover:scale-110 transition-transform`}>
                  <Icon className="w-7 h-7" />
                </div>
                <div className="text-center">
                  <h3 className="text-lg font-heading text-slate-100">{module.title}</h3>
                  <p className="text-xs text-slate-500">{module.subtitle}</p>
                </div>
              </motion.button>
            );
          })}
        </div>

        {/* Info text */}
        <p className="text-center text-slate-500 text-xs">
          Her modül pratik ve test aşamalarından oluşur
        </p>
      </motion.div>
    </div>
  );
};

export default TrainingHub;
